// extracted by mini-css-extract-plugin
var _1 = "ZXQC_JGS8EjTZjqVHUwD";
var _2 = "WgAw0BObLOp3kQbAEHhQ";
var _3 = "LEFYhGvZdsWHiwomteYj";
var _4 = "yiffnb7oFPZuiMHYQM2q";
export { _1 as "active", _2 as "container", _3 as "scroll", _4 as "wrapper" }
